import { Box, Link, Avatar as MuiAvatar, SxProps, Tooltip, Typography, styled } from "@mui/material";
import { Links } from "../constants";
import { UserDto } from "../http";
import { IUser } from "../models";
import { Avatar, AvatarSize } from "./Avatar";

const AvatarContainer = styled(Box)`
  display: flex;

  .MuiLink-root {
    margin-right: -8px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const MoreAvatar = styled(MuiAvatar)<{ $size: AvatarSize }>`
  font-size: ${({ $size }) => getMoreAvatarFontSize($size)};
  height: ${({ $size }) => getMoreAvatarSizeInPx($size)};
  width: ${({ $size }) => getMoreAvatarSizeInPx($size)};
`;

const getMoreAvatarFontSize = (size: AvatarSize) => {
  switch (size) {
    case "xsmall":
      return "12px";
    case "small":
      return "13px";
    case "large":
    default:
      return "16px";
  }
};

const getMoreAvatarSizeInPx = (size: AvatarSize) => {
  switch (size) {
    case "xsmall":
      return "24px";
    case "small":
      return "36px";
    case "large":
    default:
      return "60px";
  }
};

interface IProps {
  users: IUser[] | UserDto[];
  max: number;
  avatarComponent?: (user: IUser | UserDto, avatarProps?: AvatarProps) => React.ReactNode;
  avatarProps?: AvatarProps;
  sx?: SxProps;
}

interface AvatarProps {
  size?: "xsmall" | "small" | "large";
}

const AvatarGroup = (props: IProps) => {
  const total = props.users.length;
  const max = Math.min(total, props.max);
  const extra = total - max;
  const size = props.avatarProps?.size ?? "small";

  return (
    <AvatarContainer sx={props.sx}>
      {[...props.users]
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .slice(0, max)
        .map((u, i) => (
          <Link key={i} href={Links.User(u.userId)} underline="none">
            {props.avatarComponent ? (
              props.avatarComponent(u, props.avatarProps)
            ) : (
              <Avatar user={u} tooltip border {...props.avatarProps} />
            )}
          </Link>
        ))}

      {extra > 0 && (
        <Tooltip
          title={[...props.users]
            .sort((a, b) => a.displayName.localeCompare(b.displayName))
            .slice(max, total)
            .map((u, i) => (
              <Link key={i} href={Links.User(u.userId)}>
                <Typography sx={{ fontSize: 13 }}>{u.displayName}</Typography>
              </Link>
            ))}
        >
          <MoreAvatar $size={size}>+{extra}</MoreAvatar>
        </Tooltip>
      )}
    </AvatarContainer>
  );
};

export { AvatarGroup };
